import { Component } from '@angular/core';
import { ViewersService } from '../../../services/viewers.service';
import { DvmModule } from '@3ddv/ngx-dvm-internal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-minimap',
  imports: [DvmModule],
  templateUrl: './minimap.component.html',
  styleUrl: './minimap.component.css'
})
export class MinimapComponent {
  private subscriptions: Subscription[] = [];
  public currentMap!: 'topview' | 'seatmap';
  // public is3dView!: boolean;

  constructor(
    public readonly viewersService: ViewersService
  ) { }

  ngOnInit(): void {
    this.updateViewStep();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private updateViewStep(): void {
    // Get Map View status
    const current = this.viewersService.currentMap.subscribe((current: 'topview' | 'seatmap') => {
      // console.log('currentMap', current);
      this.currentMap = current;
    });
    this.subscriptions.push(current);
    // Get 3D View status
    // const is3d = this.viewersService.is3dView.subscribe((is3d: boolean) => {
    //   this.is3dView = is3d;
    // });
    // this.subscriptions.push(is3d, current);
  }
  
}
